import { render } from "./WebApps.vue?vue&type=template&id=13d6b140&scoped=true"
import script from "./WebApps.vue?vue&type=script&lang=js"
export * from "./WebApps.vue?vue&type=script&lang=js"

import "./WebApps.vue?vue&type=style&index=0&id=13d6b140&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d6b140"]])

export default __exports__